import { featured } from '@/mocks/home';

export default function FeatureRail() {
  return (
    <section id="featured" className="relative w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex items-end justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-accent-600">
              <i className="ri-medal-fill" /> FEATURED
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              压轴档 · 顶配盘点
            </h2>
          </div>
          <div className="hidden items-center gap-2 sm:flex">
            <button
              type="button"
              aria-label="上一条"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-secondary-400 hover:text-foreground-950"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <button
              type="button"
              aria-label="下一条"
              className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-300 text-foreground-700 transition-colors hover:border-secondary-400 hover:text-foreground-950"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>

        <div className="no-scrollbar -mx-4 mt-7 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-1 md:px-6">
          {featured.map((item, idx) => (
            <a
              key={item.title}
              href="#featured"
              className="group w-64 shrink-0 snap-start cursor-pointer overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-all hover:-translate-y-1 hover:border-background-300 md:w-72"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span
                  className={`absolute left-3 top-3 rounded-md px-2 py-1 text-xs font-bold text-background-50 ${
                    idx === 0 ? 'bg-accent-500' : idx % 2 ? 'bg-secondary-600' : 'bg-primary-600'
                  }`}
                >
                  {item.tag} 榜
                </span>
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8">
                  <span className="text-xs font-medium text-background-100/80">#{String(idx + 1).padStart(2, '0')}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-primary-600">
                  查看完整盘点 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </a>
          ))}

          <a
            href="#subscribe"
            className="group flex w-64 shrink-0 snap-start flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 text-center transition-colors hover:border-primary-400 md:w-72"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-100 text-primary-600 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className="ri-add-line text-2xl" />
            </span>
            <span className="mt-3 text-sm font-bold text-foreground-900">查看更多压轴内容</span>
            <span className="mt-1 text-xs text-foreground-600">下期顶配盘点已排期</span>
          </a>
        </div>
      </div>
    </section>
  );
}